/**
 * Detecta si la aplicación está siendo ejecutada dentro de un iframe
 * @returns {boolean} true si está en un iframe, false si no
 */
export const isEmbedded = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        // Si hay un error al acceder a window.top (por políticas de seguridad)
        // es porque estamos en un iframe de otro dominio
        return true;
    }
};
